<div class="d-flex justify-content-around justify-content-md-between align-items-center mpup-navigation-container">

  <a routerLink="/mpup/inventory" [class.active]="isActive('/mpup/inventory')">
    <div class="mpup-navigation-item-outer-circle">
      <span
        class="mpup-navigation-item-circle"
        [class.active]="isActive('/mpup/inventory')"
        (mouseenter)="inventorySrc = getImagePath('inventory', true)"
        (mouseleave)="inventorySrc = getImagePath('inventory', isActive('/mpup/inventory'))"
      >
        <img [alt]="'mpupNavigation.inventory' | mbTranslate"
             [src]="inventorySrc"
             [title]="'mpupNavigation.inventory' | mbTranslate"
        />
      </span>
    </div>
    {{'mpupNavigation.inventory' | mbTranslate}}
  </a>

  <a routerLink="/mpup/transactions" [class.active]="isActive('/mpup/transactions')" style="display: none">
    <div class="mpup-navigation-item-outer-circle">
      <span
        class="mpup-navigation-item-circle"
        [class.active]="isActive('/mpup/transactions')"
        (mouseenter)="transactionsSrc = getImagePath('transactions', true)"
        (mouseleave)="transactionsSrc = getImagePath('transactions', isActive('/mpup/transactions'))"
      >
        <img [alt]="'mpupNavigation.transactions' | mbTranslate"
             [src]="transactionsSrc"
             [title]="'mpupNavigation.transactions' | mbTranslate"
        />
      </span>
    </div>
    {{'mpupNavigation.transactions' | mbTranslate}}
  </a>

  <a routerLink="/mpup/accesspasses" [class.active]="isActive('/mpup/accesspasses')" style="display: none">
    <div class="mpup-navigation-item-outer-circle">
      <span
        class="mpup-navigation-item-circle"
        [class.active]="isActive('/mpup/accesspasses')"
        (mouseenter)="accessPassesSrc = getImagePath('accesspasses', true)"
        (mouseleave)="accessPassesSrc = getImagePath('accesspasses', isActive('/mpup/accesspasses'))"
      >
        <img [alt]="'mpupNavigation.user' | mbTranslate"
             [src]="accessPassesSrc"
             [title]="'mpupNavigation.user' | mbTranslate"
        />
      </span>
    </div>
    {{'mpupNavigation.user' | mbTranslate}}
  </a>

</div>
